import { List } from "models/list";
import { doDelete, doGet, doPost } from "services/request";

export const adminDoGetListTemplates = async () => {
  // NOTE, a different endpoint for reading the templates
  const listTemplates = await doGet<List[]>("/admin/list-templates");
  return listTemplates;
};

export const adminDoPostListTemplate = async (template: string) => {
  const listTemplate = await doPost<List>(`/admin/settings/list-template`, {
    template,
  });
  return listTemplate;
};

export const adminDoDeleteListTemplate = async (listTemplateUuid: string) => {
  await doDelete(`/admin/settings/list-template/${listTemplateUuid}`);
};

export const adminDoGetListTemplate = async (listUuid: string) => {
  const listTemplate = await doGet<List>(
    `/admin/settings/list-template/${listUuid}`,
  );
  return listTemplate;
};
